import type { ThemeAssets } from 'config/theme-assets';
import { validateThemeAssets2D } from 'config/theme-validation-utils';
import { Board } from 'model/board/types';
import { testImageUrl } from 'plugins/assets/helpers/test-image-url';

/**
 * Promise, which resolves when board url can be downloaded, and rejects otherwise
 * @param themeAssets
 */
export function verifyBoardAssetExistence(themeAssets: ThemeAssets.Assets) {
  return new Promise<boolean>((resolve, reject) => {
    try {
      validateThemeAssets2D(themeAssets);
    } catch {
      // don't validate assets for invalid or 3D assets
      return resolve(true);
    }

    testImageUrl(themeAssets.board.assets.background)
      .then(() => resolve(true))
      .catch((err) => {
        reject(new Board.StylesSetFailed(err.message));
      });
  });
}
